import React from "react";
import HyvidAwardsTab from "./components/HyvidAwardsTab";
import ShortHeaderComponent from "./components/ShortHeaderComponent";
import { Award } from "lucide-react";

const HyvidAwards = () => {
  return (
    <div className="flex flex-col gap-6">
      <ShortHeaderComponent
        icon={Award}
        title={"Rewards & Recognition"}
        description={"Nominate exceptional team members for awards and celebrate achievements"}
      />
      <HyvidAwardsTab/>
    </div>
  );
};



export default HyvidAwards;
